
let prefix = '/api/indicatorsResult';

function getResults(id){
    return window.axios.get(prefix+'/getIndResult/'+id);
}
function getDateResults({ id, fecha }){
    return window.axios.get(prefix+'/getDateResult/',{params: {id,fecha}
});
}
function store(data){
    return window.axios.post(prefix+'/store', data);
}
function upsert(data){
    return window.axios.post(prefix+'/upsert', data);
}
function update(id, data){
    return window.axios.put(prefix+'/'+id, data);
}
function deleteResult(id){
    return window.axios.delete(prefix+'/'+id);
}

export default {
    getResults,
    getDateResults,
    store,
    upsert,
    update,
    deleteResult,
}